module.exports = __webpack_public_path__ + "static/media/walletIcon.0f1863c0.svg";